export const locale = {
    lang: 'es',
    data: {
        'SAMPLE': {
            'HELLO': 'Merhaba Dünya!'
        },
        'UNKNOWN_ERROR': 'An unknown error has ocurred!!',
        'ACCEPT': 'OK',
        'ERROR': 'Error',
        'ERRORS': [
            {
                'id': '1',
                'status': '401',
                'code': '1',
                'title': 'Unauthorized',
                'detail': 'You have no access to the system'
            }
        ]
    }
};
